function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("defs", null);

var _ref2 =
/*#__PURE__*/
React.createElement("title", null, "ic-menu");

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  className: "cls-1",
  d: "M32.18,130.5h0A33.55,33.55,0,0,1,65.68,97H220.76c19.6,0,35.46,16,34.23,35.62A33.56,33.56,0,0,1,221.55,164H65.68C47.22,164.68,32.18,149.64,32.18,130.5Z",
  transform: "translate(-31.41 -97)"
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  className: "cls-1",
  d: "M31.41,255.5h0A33.55,33.55,0,0,1,64.91,222H446.29c19.6,0,35.46,16.05,34.23,35.62A33.56,33.56,0,0,1,447.09,289H65.6C46.45,289.68,31.41,274.64,31.41,255.5Z",
  transform: "translate(-31.41 -97)"
});

var _ref5 =
/*#__PURE__*/
React.createElement("path", {
  className: "cls-1",
  d: "M324.29,381.5h0a33.55,33.55,0,0,0-33.5-33.5H66.66c-19.6,0-35.46,16.05-34.23,35.62A33.56,33.56,0,0,0,65.86,415H290.79A33.55,33.55,0,0,0,324.29,381.5Z",
  transform: "translate(-31.41 -97)"
});

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    viewBox: "0 0 449.17 318"
  }, props), _ref, _ref2, _ref3, _ref4, _ref5);
};

export default __webpack_public_path__ + "static/media/ic-menu.74993eea.svg";
export { SvgComponent as ReactComponent };